import { Specification } from './specification.model';
import { ParameterType } from './parameter-type.model';
import { ParameterPreConfiguredValue } from './parameter-pre-configured-value.model';

export class ParameterSpecification {
    parameterCode: string;
    parameterName: string;
    parameterType?: ParameterType;
    testCode: string;
    testName: string;
    standardSpecification?: Specification;
    servingSpecification?: Specification;
    dailyValueSpecification?: Specification;
    labelClaimSpecification?: Specification;
    analyses: CommercialItem[];
    required: boolean;
    listValues?: ParameterPreConfiguredValue[];
    isSelectAll? : boolean;
    selected?: boolean;
}

interface CommercialItem {
    code: string;
    name: string;
}
